import theme from "../../../js/shared/new-theme"

export const defaultStyle = (color, outline, disabled) => {
    const palette = theme.palette;
    return `
	width: 100%;
	button {
		color: ${outline ? color : palette.common.white};
	}
	${disabled &&
        `button:disabled + i {
		color: ${palette.gray[500].value};
	}`}
	button:focus,button:hover{
		color: ${palette.common.white};
	}
`;
};